export default function PHP_str_ireplace() {
  return (
    <div>
      <h1>PHP_str_ireplace</h1>
    </div>
  );
}
